import { CUBE_COLORS } from './colors.js';

// Color mapping for cube faces
const COLORS = {
    'U': 'white',
    'R': 'red',
    'F': '#00aa00',
    'D': 'yellow',
    'L': 'orange',
    'B': 'blue',
    'X': 'darkgray',
    'o': '#fdfdc6',
    'x': 'blueviolet',
    'y': 'magenta'
};

// Helper function to scale canvas for retina displays
function scaleCanvas(canvas, ctx) {
    const dpr = window.devicePixelRatio || 1;
    canvas.style.width = canvas.width + 'px';
    canvas.style.height = canvas.height + 'px';
    canvas.width = canvas.width * dpr;
    canvas.height = canvas.height * dpr;
    ctx.scale(dpr, dpr);
}

// Create a 2D visualization of the Rubik's Cube
export function visualizeCube(state) {
    const sc = 35; // scale factor = length of each sticker in pixels
    const canvas = document.createElement('canvas');
    canvas.width = 13 * sc;
    canvas.height = 10 * sc;
    const ctx = canvas.getContext('2d');
    
    // Apply retina display scaling
    scaleCanvas(canvas, ctx);
    
    // Add a small offset for better alignment
    ctx.translate(sc / 2, sc / 2);
    
    // Draw function to render a face
    function draw(startIdx, row, col) {
        for (let i = row; i <= row + 2; i++) {
            for (let j = col; j <= col + 2; j++) {
                const idx = startIdx + (i - row) * 3 + (j - col);
                
                // Get color for the sticker
                ctx.fillStyle = COLORS[state[idx]] || '#CCCCCC';
                ctx.fillRect(sc * j, sc * i, sc, sc);
                
                // Draw border
                ctx.strokeStyle = '#000';
                ctx.lineWidth = 2;
                ctx.strokeRect(sc * j, sc * i, sc, sc);
                
                // Add index number
                ctx.fillStyle = '#000';
                ctx.font = `${sc/2}px Arial`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(idx.toString(), sc * j + sc/2, sc * i + sc/2);
            }
        }
    }
    
    // Draw faces in standard cube net layout
    draw(0, 0, 3);    // Up face
    draw(9, 3, 6);    // Right face
    draw(18, 3, 3);   // Front face
    draw(27, 6, 3);   // Down face
    draw(36, 3, 0);   // Left face
    draw(45, 3, 9);   // Back face
    
    return canvas;
} 